import ResultsBox from './ResultsBox';

export default ResultsBox;
